import { FormattedMessage } from 'react-intl';

const loadingRows = Array.from({ length: 3 }, (_, slot) => `row-${String(slot)}`);

export default function AccountsListLoadingState() {
  return (
    <div className="font-sans" aria-busy="true" aria-live="polite">
      <div className="mb-6 animate-pulse">
        <div className="h-8 w-64 rounded-lg bg-slate-200" />
      </div>

      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white/90 shadow-xl shadow-slate-200/60 animate-pulse">
        <table className="w-full min-w-[900px]">
          <thead className="bg-slate-50/80">
            <tr>
              <th className="w-10 px-2 py-3" />
              <th className="px-4 py-3 text-left"><div className="h-3 w-16 rounded bg-slate-200" /></th>
              <th className="px-4 py-3 text-left"><div className="h-3 w-12 rounded bg-slate-200" /></th>
              <th className="px-4 py-3 text-left"><div className="h-3 w-16 rounded bg-slate-200" /></th>
              <th className="px-4 py-3 text-left"><div className="h-3 w-20 rounded bg-slate-200" /></th>
              <th className="px-4 py-3 text-left"><div className="h-3 w-28 rounded bg-slate-200" /></th>
              <th className="px-4 py-3 text-left"><div className="h-3 w-14 rounded bg-slate-200" /></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {loadingRows.map((row) => (
              <tr key={row}>
                <td className="px-2 py-3" />
                <td className="px-4 py-3">
                  <div className="space-y-2">
                    <div className="h-4 w-40 rounded bg-slate-200" />
                    <div className="h-3 w-16 rounded bg-slate-200" />
                  </div>
                </td>
                <td className="px-4 py-3">
                  <div className="h-6 w-16 rounded-full bg-slate-200" />
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    <div className="h-4 w-16 rounded bg-slate-200" />
                    <div className="h-5 w-14 rounded-full bg-slate-200" />
                  </div>
                </td>
                <td className="px-4 py-3">
                  <div className="h-4 w-32 rounded bg-slate-200" />
                </td>
                <td className="px-4 py-3">
                  <div className="space-y-1">
                    <div className="h-4 w-20 rounded bg-slate-200" />
                    <div className="h-3 w-24 rounded bg-slate-200" />
                  </div>
                </td>
                <td className="px-4 py-3">
                  <div className="flex gap-2">
                    <div className="h-8 w-20 rounded-lg bg-slate-200" />
                    <div className="h-8 w-16 rounded-lg bg-slate-200" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-4">
        <div className="inline-flex items-center gap-2 rounded-xl border-2 border-dashed border-slate-200 px-4 py-2.5">
          <div className="h-5 w-5 rounded-full bg-slate-200" />
          <div className="h-4 w-40 rounded bg-slate-200" />
        </div>
      </div>

      <span className="sr-only">
        <FormattedMessage id="accounts.list.loading" />
      </span>
    </div>
  );
}
